import React from 'react';

export const SourceTypeUnknown = (props: { size: number } = { size: 24 }) => (
  <svg viewBox="0 0 32 32" width={props.size} height={props.size}>
    <g>
      <rect width="32" height="32" fill="#575757" rx="3" x="0" y="0"></rect>
      <text
        fill="rgb(255, 255, 255)"
        style={{
          fontSize: '11px',
          fontWeight: '700',
        }}
        x="10"
        y="20"
      >
        ---
      </text>
    </g>
  </svg>
);
